<template>
  <div class="boss-main-container">
    <div class="boss-main-wrap boss-main-content-wrap">
      <setting-header
        :breadcrumbs="[{ name: '各種設定' }, { name: 'スカウトテンプレート一覧', pathName: 'settingScoutTemplates' }]"
        :title="'スカウトテンプレート'+formTypeLabel"
        data-test="title"
      />
      <div>
        <div class="boss-scout-send-container">
          <dl class="boss-scout-send-wrap cleafix">
            <dt class="boss-scout-send-left">
              テンプレート名
              <small>（50文字以内）</small>
            </dt>
            <dd class="boss-scout-send-right">
              <input
                v-model="message.name"
                class="boss-send-subject pega-height-35"
                type="text"
                data-test="text-template-title"
              >
            </dd>
            <dt class="boss-scout-send-left">
              件名<small>（200文字以内）</small>
            </dt>
            <dd class="boss-scout-send-right">
              <input
                v-model="message.subject"
                class="boss-send-subject pega-height-35"
                type="text"
                data-test="message-subject"
              >
            </dd>
            <dt class="boss-scout-send-left">
              本文
              <small>（12000文字以内）</small>
            </dt>
            <dd class="boss-scout-send-right">
              <div class="boss-textarea-button">
                <button
                  class="boss-button"
                  type="button"
                  data-test="insertion-user-id"
                  @click="insertionValue('■USER_ID■ 様')"
                >
                  会員IDを挿入
                </button>
                <button
                  class="boss-button"
                  type="button"
                  data-test="insertion-company-name"
                  @click="insertionValue(currentUser.companyName)"
                >
                  社名を挿入
                </button>
              </div>
              <textarea
                ref="message"
                v-model="message.body"
                data-test="message-body"
                class="boss-send-textarea"
                rows
                cols
              />
            </dd>
            <dt class="boss-scout-send-left">
              スカウト特典（任意）
            </dt>
            <dd class="boss-scout-send-right boss-bonus-container">
              <!-- v-forだと改行されないためスタイルで対応 -->
              <label
                v-for="(specialFavor, i) in specialFavors"
                :key="i"
                v-tooltip="{ content: specialFavor.description}"
                class="boss-scout-bonus pega-mr-5 pega-input"
              ><input
                 v-model="message.specialFavorIds"
                 :value="specialFavor.id"
                 :data-test="'special-favor-' + specialFavor.id"
                 class="boss-bonus-check"
                 type="checkbox"
               >
                <span
                  :data-test="'special-favor-name-' + specialFavor.id"
                  class="boss-bonus-check-text boss-bonus-check-mark"
                >{{ specialFavor.name }}</span>
              </label>
            </dd>
          </dl>
        </div>
      </div>
      <div class="boss-layout boss-layout-center margin-bottom-1">
        <button
          :disabled="isConfirmButtonDisabled"
          data-test="confirmation"
          class="boss-button boss-button-confirm pega-button"
          @click="onRegisterClick"
        >
          <span
            class="boss-button-confirm-text"
            data-test="confirm-button"
          >
            この内容でテンプレートを{{ formTypeLabel }}する</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import SettingHeader from '@/components/atoms/SettingHeader'
import { mapGetters } from 'vuex'

export default {
  components: {
    SettingHeader
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      message: {
        name: '新規テンプレート',
        subject: '',
        body: '',
        specialFavorIds: []
      }
    }
  },
  computed: {
    isEmptySubject () {
      return this.message.subject.trim().length === 0
    },
    isEmptyBody () {
      return this.message.body.trim().length === 0
    },
    isEmptyTemplate () {
      return this.message.name.trim().length === 0
    },
    isConfirmButtonDisabled () {
      return this.isEmptySubject ||
        this.isEmptyBody ||
        this.isEmptyTemplate
    },
    ...mapGetters({
      specialFavors: 'specialFavorsMaster',
      currentUser: 'currentUser'
    }),
    formTypeLabel () {
      return this.id ? '編集' : '登録'
    }
  },
  created () {
    this.id && this.fetchScoutTemplate()
  },
  methods: {
    insertionValue (value) {
      const cursorPosition = this.$refs.message.selectionStart
      this.$set(this.message, 'body', this.message.body.substr(0, cursorPosition) + value + this.message.body.substr(cursorPosition, this.message.body.length))
    },
    fetchScoutTemplate () {
      this.$http.secured.get(`/company/scout/message/templates/${this.id}`)
        .then(response => {
          this.$set(this.message, 'name', response.data.name)
          this.$set(this.message, 'subject', response.data.subject)
          this.$set(this.message, 'body', response.data.body)
          this.$set(this.message, 'specialFavorIds', response.data.specialFavorIds)
        })
    },
    onRegisterClick () {
      this.$emit('submit', this.message)
    }
  }
}
</script>
